import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import ThemeMui from '@digital-hig/theme-mui/lib/theme-mui-light';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { getCurrentPathName, getLocaleFromPath } from '../common/utilities';
import { DEFAULT_LANGUAGE } from '../constants/app-constants';

const PageWrapper = ({
  className, children,
}) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const param = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const hostname = window?.location?.hostname || '';
    const localeKey = getLocaleFromPath(param?.locale, hostname);
    if (param?.locale && localeKey === DEFAULT_LANGUAGE) {
      const url = getCurrentPathName(location);
      navigate(url);
    }
    i18n.changeLanguage(localeKey);
  }, [location, i18n, param]);

  return (
    <ThemeMui baseThemeName="dhig2021">
      <Helmet key="helmet">
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <RootElement className={`${className} style-override`}>
        {children}
      </RootElement>
    </ThemeMui>
  );
};
const RootElement = styled.div`
  position:relative;
 
  h1, h2 {
    font-family: 'ArtifaktLegend';
  }
  
 `;

PageWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

PageWrapper.defaultProps = {
  className: '',
};

export default PageWrapper;
